module.exports = __webpack_public_path__ + "img/1.bb6bd8bc.png";